module.exports = __webpack_public_path__ + "media/images/vp/icon.geo.red-e811e863aa80fe8afad0bd32cd88a3d7.svg";